module.exports = __webpack_public_path__ + "img/pc_banner_sup_accout.56885e3b.webp";